import {
  Action,
  GetAggregatedAccountActionParams,
  GetAggregatedAccountActionResponse,
  GetAllowedNetworksForAddressActionParams,
  GetAllowedNetworksForAddressActionResponse,
  GetCollectionByIdActionParams,
  GetCollectionByIdActionResponse,
  GetCollectionsActionParams,
  GetCollectionsActionResponse,
  GetCollectionsByIdsActionParams,
  GetCollectionsByIdsActionResponse,
  GetEmailOrUsernameMapActionParams,
  GetEmailOrUsernameMapActionResponse,
  GetFileByChecksumActionParams,
  GetFileByChecksumActionResponse,
  GetFileByIdActionParams,
  GetFileByIdActionResponse,
  GetFilesActionParams,
  GetFilesActionResponse,
  GetFilesByIdsActionParams,
  GetFilesByIdsActionResponse,
  GetNotificationDataActionParams,
  GetNotificationDataActionResponse,
  GetStorageStatisticsActionParams,
  GetStorageStatisticsActionResponse,
  SetReadAllStatusActionParams,
  SetReadAllStatusActionResponse,
  SetReadStatusActionParams,
  SetReadStatusActionResponse,
} from '@stellab/cs-schemas';

import config from '@/config';

import { getAxios, postAction } from './axios';

export const clientIsOnline = async () => {
  const url = `${config.backend}/blockchain/status`;

  return getAxios()
    .get(url)
    .then(res => res.data);
};

export const getAggregatedAccount = async (params: GetAggregatedAccountActionParams) => {
  const result = await postAction<GetAggregatedAccountActionResponse>({
    action: Action.GetAggregatedAccount,
    params,
  });

  return result.data;
};

export const getMapByEmailHashOrUsername = async (params: GetEmailOrUsernameMapActionParams) => {
  const result = await postAction<GetEmailOrUsernameMapActionResponse>({
    action: Action.GetEmailOrUsernameMap,
    params,
  });

  return result.data;
};

export const getFiles = async (params: GetFilesActionParams = {}) => {
  const result = await postAction<GetFilesActionResponse>({
    action: Action.GetFiles,
    params,
  });

  return result.data;
};

export const getFilesByIds = async (params: GetFilesByIdsActionParams) => {
  const result = await postAction<GetFilesByIdsActionResponse>({
    action: Action.GetFilesByIds,
    params,
  });

  return result.data;
};

export const getFileById = async (params: GetFileByIdActionParams) => {
  const result = await postAction<GetFileByIdActionResponse>({
    action: Action.GetFileById,
    params,
  });

  return result.data;
};

export const getFileByChecksum = async (params: GetFileByChecksumActionParams) => {
  const result = await postAction<GetFileByChecksumActionResponse>({
    action: Action.GetFileByChecksum,
    params,
  });

  return result.data;
};

export const getCollections = async (params: GetCollectionsActionParams) => {
  const result = await postAction<GetCollectionsActionResponse>({
    action: Action.GetCollections,
    params,
  });

  return result.data;
};

export const getCollectionsByIds = async (params: GetCollectionsByIdsActionParams) => {
  const result = await postAction<GetCollectionsByIdsActionResponse>({
    action: Action.GetCollectionsByIds,
    params,
  });

  return result.data;
};

export const getCollectionById = async (params: GetCollectionByIdActionParams) => {
  const result = await postAction<GetCollectionByIdActionResponse>({
    action: Action.GetCollectionById,
    params,
  });

  return result.data;
};

export const getStorageStatistics = async (params: GetStorageStatisticsActionParams) => {
  const result = await postAction<GetStorageStatisticsActionResponse>({
    action: Action.GetStorageStatistics,
    params,
  });

  return result.data;
};

export const getNotifications = async (params: GetNotificationDataActionParams) => {
  if (!params.address) {
    return [];
  }

  const result = await postAction<GetNotificationDataActionResponse>({
    action: Action.GetNotificationData,
    params,
  });

  return result;
};

export const setReadStatus = async (params: SetReadStatusActionParams) => {
  const result = await postAction<SetReadStatusActionResponse>({
    action: Action.SetReadStatus,
    params,
  });

  return result;
};

export const setReadAllStatus = async (params: SetReadAllStatusActionParams) => {
  const result = await postAction<SetReadAllStatusActionResponse>({
    action: Action.SetReadAllStatus,
    params,
  });

  return result;
};

export const getAllowedNetworksForAddress = async (params?: GetAllowedNetworksForAddressActionParams) => {
  if (!params) {
    return [];
  }

  const result = await postAction<GetAllowedNetworksForAddressActionResponse>({
    action: Action.GetAllowedNetworksForAddress,
    params,
  });

  return result.data;
};
